// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"51b5c282","374":"530d7c00","453":"1d6788a1"}[chunkId] + ".chunk.js";
};